<div class="overlay" (click)="close()"></div>

<div class="modal" *ngIf="types && model && fields">
    <div align="center" *ngIf="pages" style="height: 50px">
        <app-paginator [pages]="pages" [current]="current" (onChangePage)="changed($event)"></app-paginator>
    </div>

    <div class="table" style="display: block; width: 100%; height: 85%; overflow: auto">
        <table border="1">
            <tr class="header-row">
                <td></td>
                <td class="header" *ngFor="let field of fields"><b>{{ model[field] }}</b></td>
            </tr>
            <tr class="header-row">
                <td>
                    <button (click)="search()">
                        <i class="fas fa-search"></i>
                    </button>
                </td>
                <td *ngFor="let field of fields" [ngSwitch]="types[field]" class="header">
                    <select *ngSwitchCase="'enum'" (change)="find_model[field] = $event.target.value" value="0">
                        <option *ngFor="let item of types[field + '_enum'] | keyvalue" [value]="item.key">{{ item.value }}</option>
                    </select>
                    <textarea *ngSwitchCase="'text'" [(ngModel)]="find_model[field]" placeholder="{{ model[field] }}" rows="1"></textarea>
                    <ng-container *ngSwitchCase="'file:Image'"></ng-container>
                    <input *ngSwitchDefault [(ngModel)]="find_model[field]" [pattern]="pattern[types[field]]" placeholder="{{ model[field] }}">
                </td>
            </tr>
            <ng-container *ngIf="data">
                <tr *ngFor="let row of data; let i = index" [ngClass]="{'row-0': (i % 2) == 0, 'row-1': (i % 2) == 1}">
                    <td>
                        <button (click)="send(row[fields[0]])">
                            <i class="fas fa-caret-square-left"></i>
                        </button>
                    </td>
                    <td *ngFor="let field of fields" [ngSwitch]="types[field]">
                        <ng-container *ngSwitchCase="'file:Image'">
                            <img *ngIf="row[field]" width="200px" src="{{ url + row[field] }}">
                        </ng-container>
                        <div *ngSwitchCase="'enum'">{{ types[field + '_enum'][row[field]] }}</div>
                        <div *ngSwitchDefault>
                            {{ row.names && row.names[field] && row.names[field](row) || row[field] }}
                        </div>
                    </td>
                </tr>
            </ng-container>
        </table>
    </div>

    <div align="center" *ngIf="pages" style="height: 50px">
        <app-paginator [pages]="pages" [current]="current" (onChangePage)="changed($event)"></app-paginator>
    </div>
</div>
